import { createSlice } from "@reduxjs/toolkit";
import { getComments, postComment, toggleCommentLike } from "./commentsActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  commentsData: {},
};
const commentsSlice = createSlice({
  name: "comments",
  initialState,
  reducers: {
    resetCommentsError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
    resetComments: (state) => {
      state.commentsData = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getComments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getComments.fulfilled, (state, action) => {
        state.loading = false;
        state.commentsData = action.payload;
      })
      .addCase(getComments.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(postComment.pending, (state) => {
        state.loading = true;
      })
      .addCase(postComment.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(postComment.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // No pending/rejected handlers — avoids setting the shared loading flag
      // which would disable the comment textarea and dropdown. Errors are
      // handled locally in the component with optimistic rollback.
      .addCase(toggleCommentLike.fulfilled, (state, action) => {
        const { comment_id, is_liked, likes_count } = action.payload;
        const results = state.commentsData?.results;
        if (results) {
          const comment = results.find((c) => c.id === comment_id);
          if (comment) {
            comment.is_liked = is_liked;
            comment.likes_count = likes_count;
          }
        }
      });
  },
});

export const { resetCommentsError, resetComments } = commentsSlice.actions;
export default commentsSlice.reducer;
